import { render, staticRenderFns } from "./detail_tips_page.vue?vue&type=template&id=9de381a2&scoped=true"
import script from "./detail_tips_page.vue?vue&type=script&lang=js"
export * from "./detail_tips_page.vue?vue&type=script&lang=js"
import style0 from "./detail_tips_page.vue?vue&type=style&index=0&id=9de381a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de381a2",
  null
  
)

export default component.exports